import React from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import ModelList from "./ModelList";
import "./ProjectInfo.css";
import "./VisibilityControl.css";

const VisibilityControl: React.FC = () => {
  const { selectedGroup, setSelectedGroup, getModelGroups, config } = useConfig();
  const { t } = useLanguage();

  const groups = getModelGroups();

  const handleGroupChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedGroup(event.target.value);
  };

  return (
    <div className="info-grid">
      {groups.length > 0 && (
        <div className="group-selector-wrapper">
          <select
            className="group-selector"
            value={selectedGroup}
            onChange={handleGroupChange}
          >
            {groups.map((group) => (
              <option key={group} value={group}>
                {t(group.toLowerCase().replace(/\s+/g, "_")) || group}
              </option>
            ))}
          </select>
          <span className="dropdown-arrow">▼</span>
        </div>
      )}
      {!!config?.modelGroups.find((group) => group?.name === selectedGroup)?.description &&
        <div className="info-item">
          <div className="info-label">{t("description")}</div>
          <div className="info-value">{config?.modelGroups.find((group) => group?.name === selectedGroup)?.description}</div>
        </div>
      }
      <ModelList />
    </div>
  );
};

export default VisibilityControl;
